export const MEMBER_TYPES = {
	MEMBER_BUDGET_BUILDER: "BUDGET_BUILDER",
	MEMBER_UNNAMED: "UNNAMED",
	MEMBER_PARENT: "PARENT"
};

export const DEFAULT_BUDGET_PERIODS = {
	numberOfPeriods: 1,
	periodRows: [
		{
			periodNumber: 1,
		},
	],
};

export const STATIC_BUDGET_CATEGORIES = [ "Subawards", "All F&A", "Research Team" ];

export const READ_ONLY_BUDGET_CATEGORIES = [ "All F&A", "Research Team" ];

export const PERIOD_COUNT_OPTIONS = [
	{ value: 1, text: "1" },
	{ value: 2, text: "2" },
	{ value: 3, text: "3" },
	{ value: 4, text: "4" },
	{ value: 5, text: "5" },
	{ value: 6, text: "6" },
	{ value: 7, text: "7" },
	{ value: 8, text: "8" },
	{ value: 9, text: "9" },
	{ value: 10, text: "10" },
];

export const TYPE_DROPDOWN_OPTIONS = [
	{
		id: "1",
		text: "Cash Matching",
		value: "Cash Matching"
	},
	{
		id: "2",
		text: "In-kind",
		value: "In-kind"
	},
	{
		id: "3",
		text: "Indirect Cost",
		value: "Indirect Cost"
	},
	{
		id: "4",
		text: "Salary Cap",
		value: "Salary Cap"
	},
	{
		id: "5",
		text: "Unknown",
		value: "Unknown"
	}
];

export const REQUIREMENT_DROPDOWN_ITEMS = [
	{
		id: "mandatory",
		text: "Mandatory",
		value: "Mandatory"
	},
	{
		id: "voluntary",
		text: "Voluntary",
		value: "Voluntary"
	}
];
